export const passwordValidation = /(?=.*[^_ ])(?=.*[0-9])(?=.*)(?=.*[a-z])(?=.*[A-Z])[\S]/;
export const patientPasswordValidation = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()?|]?)(?=.*\d)[\S]+$/;
export const oneTimePasswordValidation = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]/s;
export const emailValidation = /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const strictEmailValidation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const strWithNoOnlySpaces = /[^\s]/;
export const deleteUselessChars = /[^\d]/g;
// Everything the phone field is allowed to keep: digits, plus a leading +. Used to normalise what is
// typed into exactly what is submitted, so the mask's spaces never reach the API.
export const keepPhoneChars = /[^\d+]/g;
/**
 * MUST stay identical to PhoneRegExp in the backend (src/resources/users/RegExp.js).
 *
 * A UK national number, unchanged, OR E.164. If these two ever drift, the panel either rejects a
 * number the API would take - invisible, an admin simply cannot save - or accepts one the API
 * refuses, which surfaces as an unexplained server error on a patient's record.
 */
/**
 * The only characters a phone field may CONTAIN. Not a format - a statement of what we are willing
 * to silently discard.
 *
 * transformPhone throws away separators before anything is validated, so any character not listed
 * here would be dropped without comment and the remainder checked as if it were the whole number.
 * That is how "+1 (415) 555-0132 x24" became the number +1415555013224 - the extension's digits
 * absorbed into the subscriber number, valid at every layer, and undiallable. Anything we cannot
 * interpret has to be REFUSED where the admin can see it, not quietly reinterpreted.
 */
export const phoneAllowedCharacters = /^[+\d\s().-]+$/;
export const phoneValidation = /^(?:0\d{10}|\+[1-9]\d{6,14})$/;
export const restrictMobile = /(android|avantgo|blackberry|bolt|boost|cricket|docomo|fone|hiptop|mini|mobi|palm|phone|pie|tablet|up\.browser|up\.link|webos|wos)/i;
export const restrictSafari = /^((?!chrome|android).)*safari/i;
export const onlyNumbers = /\D/g;
export const digitsWithNoSpaces = /^\d+[,.]?\d*$/;
export const lettersAndNumbers = /^[a-z0-9]+$/ig;
